import { Typography } from '@mui/material';
import React, { Fragment } from 'react';

const { useState, useEffect, useRef } = React;
//import estilos from './FormularioFC30BeneficiarioComponent.module.css';
import moment from 'moment'


const FormularioDocumentacionFC_41 = (props) => {
    //DATOS PARA GENERAR DOCUMENTACIÓN DE CONTRATOS
    const [numeroSolicitud, setNumeroSolicitud] = useState('');
    const [numCertificadoNOM, setNumCertificadoNOM] = useState('');
    const [numeroTraslado, setNumeroTraslado] = useState('');
    const [otrosServicios, setOtrosServicios] = useState('');
    const [fechaInspeccion, setFechaInspeccion] = useState(moment().format('YYYY-MM-DD'));
    const [numeroPlanEvaluacion, setNumeroPlanEvaluacion] = useState('');
    const [inspectorAsignado, setInspectorAsignado] = useState('');
    const [credencialInspector, setCredencialInspector] = useState('');
    const [telefonoInspector, setTelefonoInspector] = useState('');
    const fechaHoy = moment().format('YYYY-MM-DD')

    const botonAceptar = () => {
        const data = {
            numeroSolicitud, numCertificadoNOM, numeroTraslado, otrosServicios, fechaInspeccion, numeroPlanEvaluacion,
            inspectorAsignado, credencialInspector, telefonoInspector,
        }
        props.functionAcept(data)
    }
    return (
        <Fragment>
            <h6 className='text-center'>SOLICITUD DE SERVICIOS DE INSPECCIÓN</h6>
            <div className='row justify-content-start mb-2 text-center'>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumeroSolicitud(e.target.value)}
                            value={numeroSolicitud}
                            placeholder='No. de solicitud' />
                        <label className="floatingInput">No. de solicitud</label>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumCertificadoNOM(e.target.value)}
                            value={numCertificadoNOM}
                            placeholder='No. Certificado NOM vigente' />
                        <label className="floatingInput">No. Certificado NOM vigente</label>
                    </div>
                </div>
                {/*<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumeroTraslado(e.target.value)}
                            value={numeroTraslado}
                            placeholder='Número de traslado' />
                        <label className="floatingInput">Número de traslado</label>
                    </div>
                </div>*/}
                {/*<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setOtrosServicios(e.target.value)}
                            value={otrosServicios}
                            placeholder='Otros servicios' />
                        <label className="floatingInput">Otros servicios</label>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="date" className={`form-control`}
                            onChange={e => setFechaInspeccion(e.target.value)}
                            value={fechaInspeccion} min={fechaHoy}
                            placeholder='Fecha de inspección' />
                        <label className="floatingInput">Fecha de inspección</label>
                    </div>
                </div>*/}
            </div>
            <hr />
            <h6 className='text-center'>PLAN DE EVALUACIÓN</h6>
            <div className='row justify-content-start mb-2 text-center'>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumeroPlanEvaluacion(e.target.value)}
                            value={numeroPlanEvaluacion}
                            placeholder='No. Plan de evaluación' />
                        <label className="floatingInput">No. del plan de evaluación</label>
                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setInspectorAsignado(e.target.value)}
                            value={inspectorAsignado}
                            placeholder='No. Certificado NOM vigente' />
                        <label className="floatingInput">Inspector asignado</label>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setCredencialInspector(e.target.value)}
                            value={credencialInspector}
                            placeholder='Número de traslado' />
                        <label className="floatingInput">Credencial del inspector</label>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="form-floating mb-3">
                        <input type="number" id="floatingInput" className={`form-control`}
                            onChange={e => setTelefonoInspector(e.target.value)}
                            value={telefonoInspector}
                            placeholder='Teléfono del inspector' />
                        <label className="floatingInput">Teléfono del inspector</label>
                    </div>
                </div>
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className='text-center'>
                Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                y los datos se tomarán como válidos.<br /> <strong>¿Desea continuar?</strong>
            </Typography>
            <div className='row'>
                <button className='btn btn-success' onClick={() => botonAceptar()}
                    disabled={(numeroSolicitud == '' ||  numeroPlanEvaluacion == '' ||
                        inspectorAsignado == '' || credencialInspector == '' || telefonoInspector == '') ? true : false}
                >CONTINUAR</button>
            </div>
        </Fragment>
    );  
};

export default FormularioDocumentacionFC_41;
